/* src/app/components/auditoria/auditoria.component.scss */
.folha-auditoria {
  max-width: min(840px, 100vw);
  padding: 3em 1em;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  min-height: calc(100vh - 5rem);
  box-shadow: 6px 6px 12px #222;
}
.folha-auditoria hr {
  max-width: 50px;
  border-width: 3px;
  border-color: #380415;
}
.folha-auditoria hr.light {
  border-color: white;
}
.folha-auditoria h3 {
  font-size: 1.8rem;
  margin: 2rem 0;
}
.folha-auditoria p {
  margin: 2rem 0;
}
/*# sourceMappingURL=auditoria.component-AOAV7ZVX.css.map */
